// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_Dp0PT","delivery-wrap":"delivery-wrap_pehzZ","delivery":"delivery_eCQZn"};